import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Avatar } from "@faire/web--source/slate/deprecated/Avatar";
import { Close } from "@faire/web--source/slate/icons/foundation/Close";
import { Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { observer } from "mobx-react";
import React, { useMemo } from "react";
import styled from "styled-components";
import { getDefaultImageUrl } from "@faire/retailer/components/Image/ProgressiveProductImage";
import { useFaireDirectBrand } from "@faire/retailer/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useSettingFaireDirectSignupModalRefresh } from "@faire/retailer/settings/useSettingFaireDirectSignupModalRefresh";
var ImageOrLogoBase = function(param) {
    var renderLogo = param.logo, image = param.image, _param_isFeaturedImageLoading = param.isFeaturedImageLoading, isFeaturedImageLoading = _param_isFeaturedImageLoading === void 0 ? false : _param_isFeaturedImageLoading;
    var _useFaireDirectBrand = useFaireDirectBrand(), isFaireDirectActiveInLoggedOut = _useFaireDirectBrand.isFaireDirectActiveInLoggedOut, faireDirectBrand = _useFaireDirectBrand.faireDirectBrand;
    var isFaireDirectRefresh = useSettingFaireDirectSignupModalRefresh();
    var logo = useMemo(function() {
        return isFaireDirectActiveInLoggedOut && !isFaireDirectRefresh ? /*#__PURE__*/ _jsxs(Row, {
            align: "center",
            children: [
                /*#__PURE__*/ _jsx(Avatar, {
                    size: "x-small",
                    image: faireDirectBrand === null || faireDirectBrand === void 0 ? void 0 : faireDirectBrand.profile_image,
                    userName: faireDirectBrand === null || faireDirectBrand === void 0 ? void 0 : faireDirectBrand.name
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    width: "2x"
                }),
                /*#__PURE__*/ _jsx(Close, {
                    fontSize: "12px"
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    width: "2x"
                }),
                /*#__PURE__*/ _jsx(FaireLogo, {
                    size: 104
                })
            ]
        }) : /*#__PURE__*/ _jsx(FaireLogo, {
            size: 104
        });
    }, [
        faireDirectBrand === null || faireDirectBrand === void 0 ? void 0 : faireDirectBrand.name,
        faireDirectBrand === null || faireDirectBrand === void 0 ? void 0 : faireDirectBrand.profile_image,
        isFaireDirectActiveInLoggedOut,
        isFaireDirectRefresh
    ]);
    var isSSR = useIsSSR();
    if (renderLogo) {
        return logo;
    }
    /**
     * Logo is rendered when no image is loading or given, but during server side rendering,
     * if renderLogo is false, then we don't know what will happen in client
     * side, so we return loading spinner as the default to make sure whatever happens
     * in the client side, users will not experience a janky page.
     */ if (isFeaturedImageLoading || isSSR) {
        return /*#__PURE__*/ _jsx(Container, {
            "data-test-id": "sign-up-image-spinner",
            children: /*#__PURE__*/ _jsx(LoadingSpinner, {})
        });
    }
    if (image) {
        return /*#__PURE__*/ _jsx(Container, {
            children: /*#__PURE__*/ _jsx("img", {
                src: getDefaultImageUrl(image, isSSR, {}),
                alt: "Sign up featured image"
            })
        });
    }
    return logo;
};
var Container = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-1f370406-0"
})([
    "width:144px;height:144px;img{display:block;width:100%;}",
    "{width:112px;height:112px;}"
], responsiveMediaQueries.mobile);
export var ImageOrLogo = observer(ImageOrLogoBase);
